<template>
    <nav class="navbar navbar-expand-lg navbar-light" style="padding: 20px 0">
        <div>
            <a href="/loans" class="navbar-brand margin-left-300">
                <img width="100%" src="../assets/logo.jpg"></a>
            <span v-if="user" class="vertical"></span>
            <a class="navbar-brand" href="/loans">
                <img v-if="user" class="bank-logo" height="35" :src="user.bank_logo">
            </a>
        </div>
        <div v-if="user">
            <a class="logout" v-on:click="logout">Log out</a>
        </div>
    </nav>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'Navbar',
        data() {
            return {
                data: null
            }
        },
        computed: {
            ...mapGetters(['user'])
        },
        mounted: function () {
            let self = this;
        },
        methods: {
            userInfo() {
                const json = window.localStorage.userInfo;
                this.data = json ? JSON.parse(json) : undefined;
            },
            logout() {
                this.$store.commit('logout');
                this.$router.push({name: 'login'})
            }
        }
    }
</script>

<style scoped>
    .vertical {
        border: none;
        border-left: 2px solid hsla(200, 10%, 50%, 100);
        height: 25px;
        width: 5px;
        color: #121212;
    }

    .margin-left-300 {
        margin-left: 300px;
        margin-right: 20px;
    }

    .bank-logo {
        margin-left: 20px;
    }

    .logout {
        font-size: 18px;
        position: absolute;
        right: 320px;
        cursor: pointer;
        bottom: 30px;
        font-weight: 500;
    }
    @media only screen and (max-width: 1024px) {
        .margin-left-300{
            margin-left: 100px;
        }
        .logout{
            right: 100px;
        }
    }
</style>
